import { CONTRACT_CODE, CONTRACT_CODE_CP } from "../constants";

export const groupContractCode = (menus) => {
  const GROUP_CODES = [CONTRACT_CODE, CONTRACT_CODE_CP];

  const groupItems = menus.filter((item) =>
    GROUP_CODES.includes(item.project_code)
  );

  const otherItems = menus.filter(
    (item) => !GROUP_CODES.includes(item.project_code)
  );

  if (groupItems.length === 0) return menus;

  return [
    ...otherItems,
    {
      name: "Quản lý chứng từ",
      icon: "faFolderOpen",
      type: "fa",
      bg: "#5747b5",
      project_code: CONTRACT_CODE,
      isGroup: true,
      children: groupItems,
    },
  ];
};
